<template>
  <zt-modal
    :active="isActiveModalInfo"
    title="Enviar documento"
    @close="closeDialog"
    max-width="600px"
  >
    <template>
      <div class="flex items-center px-10 py-16">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem' }"
          />
        </div>
        <div>
          <p class="text-zt-lg">
            <span class="font-bold block">
              {{ $t('message.publishDocuments.configGenericPublish.cancel.question')}}
            </span>
            {{ $t('message.publishDocuments.configGenericPublish.cancel.message')}}
          </p>
        </div>
      </div>
    </template>

    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-center lg:justify-end items-center p-4"
      >
        <zt-button
          outlined
          data-vs-button="no-notifications"
          class="mr-1 text-primary-200"
          @click="closeDialog"
        >
        {{ $t('message.publishDocuments.configGenericPublish.action.cancel')}}
        </zt-button>
        <zt-button
          data-vs-button="with-notifications"
          @click="confirm"
        >
        {{ $t('message.publishDocuments.configGenericPublish.confirmOut')}}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
export default {
  name: 'ModalNotificationCancel',
  inject: [
    'clearPublish',
    'setActiveNotificationCancelModal',
  ],
  props: {
    isActiveModalInfo: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog() {
      this.setActiveNotificationCancelModal(false)
    },
    async confirm() {
      await this.closeDialog()
      this.$router.push({ name: 'MainDocumentPage' })
      this.clearPublish()
    }
  }
}
</script>

<style scoped>
.warning-icon {
  width: 70px;
  height: 70px;

  border-radius: 50%;
  border: 2px solid #fb8c00;
  color: #fb8c00;
}
.warning-icon i {
  font-size: 2.438rem;
}
.zt-modal-footer {
  background-color: #eee;
}
::v-deep .zt-button.text-primary-200 {
  color: #4f41a3 !important;
  background-color: #eee;
}
::v-deep .zt-modal.rounded {
  border-radius: 0.375rem !important;
}
</style>